import React, { useState } from "react";
import { useTheme } from "../../ThemeContext";
import { Modal, MantineProvider } from "@mantine/core";

const CivilProjectDocuments = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const documents = [
    { id: 1, name: "Site Plan", description: "Detailed layout of the construction site." },
    { id: 2, name: "Structural Drawings", description: "Blueprints of the structural framework." },
    { id: 3, name: "Building Permit", description: "Official approval from the local authority." },
    { id: 4, name: "Material List", description: "List of required construction materials." },
    { id: 5, name: "Safety Protocols", description: "Guidelines for ensuring site safety." },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deadline, setDeadline] = useState("");
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleDeadlineChange = (event) => setDeadline(event.target.value);
  const handleSaveDeadline = () => {
    console.log("Project Deadline Set:", deadline);
    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col md:flex-row gap-6 p-6">
      {/* Document List */}
      <div className={`flex-1 p-6 rounded-lg shadow-lg ${isDark ? "bg-gray-800" : "bg-white"}`}>
        <div className="flex justify-between mb-6">
          <h2 className={`text-2xl font-semibold ${isDark ? "text-white" : "text-gray-800"}`}>Required Documents</h2>
          <button
            className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-500 transition"
            onClick={handleOpenModal}
          >
            Add Document
          </button>
        </div>
        <ul className=" grid grid-cols-2 gap-5">
          {documents.map((doc) => (
            <li
              key={doc.id}
              className={`p-4 rounded-md shadow-sm border ${isDark ? "border-gray-600 bg-gray-700" : "border-gray-200 bg-gray-50"}`}
            >
              <strong className={`text-lg ${isDark ? "text-gray-400" : "text-gray-800"}`}>{doc.name}</strong>
              <p className={`text-sm mt-2 ${isDark ? "text-gray-300" : "text-gray-500"}`}>{doc.description}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Modal for Adding Deadline */}
      {isModalOpen && (
        <MantineProvider theme={{ colorScheme: theme }}>
          <Modal
            onClose={handleCloseModal}
            opened={isModalOpen}
            title="Add Document"
            centered
            size="md"
            overlayOpacity={0.3}
            overlayBlur={3}
          >
            <div className="space-y-6 p-6">
              <div>
                <label className="block text-sm font-medium text-gray-500">Document Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={`p-2 border rounded-md w-full mt-2 ${isDark ? "bg-gray-800 text-gray-100 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                  placeholder="Enter document name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-500">Description</label>
                <textarea
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  className={`p-2 border rounded-md w-full mt-2 ${isDark ? "bg-gray-800 text-gray-100 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                  rows="4"
                  placeholder="Enter description"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-500">Deadline</label>
                <input
                  type="date"
                  value={deadline}
                  onChange={handleDeadlineChange}
                  className={`p-2 border rounded-md w-full mt-2 ${isDark ? "bg-gray-800 text-gray-100 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                />
              </div>

              <div className="flex justify-between gap-4 mt-6">
                <button
                  onClick={handleCloseModal}
                  className="px-6 py-2 bg-gray-300 text-gray-500 rounded-md hover:bg-gray-400 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveDeadline}
                  className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-500 transition"
                >
                  Add
                </button>
              </div>
            </div>
          </Modal>
        </MantineProvider>
      )}
    </div>
  );
};

export default CivilProjectDocuments;
